import { registerLocaleData } from '@angular/common';
import de from '@angular/common/locales/de';
import en from '@angular/common/locales/en';

[de, en].forEach((data) => registerLocaleData(data));
